module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3r2r6n9n-2d4540a195ff53637f4bd1177bface54.svg";